import { Box, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import getConfig from 'next/config';
import styles from './styles';

const { publicRuntimeConfig } = getConfig();

const BroadbandPrequalSecondaryBannerCurve = props => {
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Box
      component='img'
      sx={styles(theme).SecondaryPrequalBannerCurve}
      src={
        sm
          ? `${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${props.cmsData?.secondaryMobileCurveImg?.data?.attributes?.url}`
          : `${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${props.cmsData?.secondaryDesktopCurveImg?.data?.attributes?.url}`
      }
      alt={props.cmsData?.secondaryDesktopCurveImg?.data?.attributes?.alternativeText}
    />
  );
};

export default BroadbandPrequalSecondaryBannerCurve;
